import { useEffect, useState } from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { BringgMap } from '@bringg-frontend/bringg-map';
import { observer } from 'mobx-react';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring-shared';

import useTimeFormat from 'bringg-web/hooks/use-time-format';
import { useStores } from 'bringg-web/recipes';
import useRouteMonitoringStore from '../stores/helpers/use-route-monitoring-store';
import { driversLocationListener } from '../data/drivers-location-listeners';

import styles from './routes-map.module.scss';

export const ROUTES_MAP_CLASS = 'routes-monitoring-map';
const FETCH_INTERVAL = 5000;

const RoutesMap = () => {
	const [shouldShowPlannedPath, setShouldShowPlannedPath] = useState(true);
	const [shouldShowDriverLocation, setShouldShowDriverLocation] = useState(true);

	const { mapToogleDriverLocation, mapTooglePath } = useRoutesMonitoringTranslations();

	const timeFormat = useTimeFormat();

	const {
		routesMonitoringTableViewStore: { initViewedRoutes },
		routeMonitoringMapViewStore,
		selectedTasksStore: { setSelectedTasks, selectedTasks, clearSelectedTasks }
	} = useRouteMonitoringStore();

	const { authStore } = useStores();

	useEffect(() => {
		initViewedRoutes();
		const unsubscribe = driversLocationListener.listen(FETCH_INTERVAL);

		return () => {
			unsubscribe();
		};
	}, []);

	const markers = shouldShowDriverLocation
		? routeMonitoringMapViewStore.driverMarkers.concat(routeMonitoringMapViewStore.markers || [])
		: routeMonitoringMapViewStore.markers;

	const mapButtons = [
		{
			text: mapTooglePath,
			clickHandler: () => {
				setShouldShowPlannedPath(prevState => !prevState);
			},
			'data-test-id': 'toggle-path-btn',
			className: shouldShowPlannedPath ? styles.btnActive : ''
		}
	];

	if (routeMonitoringMapViewStore.driverMarkers.length) {
		mapButtons.push({
			text: mapToogleDriverLocation,
			clickHandler: () => {
				setShouldShowDriverLocation(prevState => !prevState);
			},
			'data-test-id': 'toggle-driver-btn',
			className: shouldShowDriverLocation ? styles.btnActive : ''
		});
	}

	const onMarkerClick = (id, isCtrlClick) => {
		const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(id);
		setSelectedTasks(task, isCtrlClick);
	};

	return (
		<BringgMap
			allowTrafficLayer
			markers={markers}
			polylines={
				Array.isArray(routeMonitoringMapViewStore.polylines) && shouldShowPlannedPath
					? routeMonitoringMapViewStore.polylines
					: []
			}
			timeZone={authStore.merchant.time_zone}
			timeFormat={timeFormat}
			mapElementClassName={styles.routesMap}
			mapContainerClassName={`${ROUTES_MAP_CLASS} ${styles.routesMapContainer}`}
			fullscreenControl={false}
			buttons={mapButtons}
			forceRecenterOnAddingMarkers={true}
			onMarkerClick={onMarkerClick}
			selectedMarkers={selectedTasks.map(({ id }) => id)}
			clearSelectedMarkers={clearSelectedTasks}
		/>
	);
};

export default observer(RoutesMap);
